import { AxiosPromise } from 'axios';
import {IVisitorTypeFormValues} from '../form';
import { instance } from '../../../../services';

const createVisitorType = (data: IVisitorTypeFormValues): AxiosPromise =>
  instance.post('/api/visitorTypes', data);

export default createVisitorType;
